import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface IDistributeDiagramNodesOptions {
    modeStr: string;
    distanceX: number;
    distanceY: number;
}

@Component
export default class DistributeDiagramNodesDialog extends Vue {

    @Prop()
    value: IDistributeDiagramNodesOptions;
    //}

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    onExportClick() {
        this.$emit("dialogClosed", "ok", this.value);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/distribute-diagram-nodes-dialog/distribute-diagram-nodes-dialog.ts